import React, {useState, useEffect} from "react";
import {DEFAULT_BLUE} from "../../../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import CircularProgress from '@material-ui/core/CircularProgress';
import {functions} from "../../../constants/common-functions";
import * as adminStyles from "./AdminStyles";

export default function EditButtonPanel({goSubmit, goDelete, goCancel, checkCodeUrl, getCodeFunction, getNameFunction, id}){
	
	const [displayProgress, setDisplayProgress] = useState("flex");
	const [displayWarning, setDisplayWarning] = useState("none");
	const [warningMessage, setWarningMessage] =  useState("");
	const [displayNormalButtons, setDisplayNormalButtons] =  useState("flex");
	const [displayDeleteButtons, setDisplayDeleteButtons] =  useState("none");
	
	useEffect(() => {
		progressTimer();
	}, [id]);
	
	const progressTimer = () => {
		const timer = setTimeout(() => {
			setDisplayProgress("none");
		}, 2000);
	};
	
	const editFooter = {
		display:"flex",
		height:"80px",
		width:"calc(100% - 60px)",
		position:"fixed",
		bottom:"0px",
		left:"60px",
		backgroundColor:"black",
		justifyContent:"space-around",
		alignItems:'center'
	};
	
	const editButtonContainer = {
		display:"flex"
	};
	
	
	const progressContainer = {
		display:displayProgress,
		width:"100%",
		height:"calc(100vh - 0px)",
		backgroundColor:"white",
		flexDirection:"column",
		zIndex:"2000",
		color:DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		position:"fixed",
		top:"0px",
		left:"0px"
	};
	
	const warningPopup = {
	  display: displayWarning,
	  position: "fixed",
	  top: "35vh",
	  left: "50%",
	  transform: "translateX(-50%)",

	  backgroundColor: "#ffffff",
	  width: "460px",
	  minHeight: "220px",
	  flexDirection: "column",

	  borderRadius: "10px",

	  boxShadow:
	    "0 10px 25px rgba(0,0,0,0.25), 0 2px 8px rgba(0,0,0,0.15)",

	  zIndex: 1000
	};
	
	const warningTriangle = {
	  display: "flex",
	  alignSelf: "center",
	  height: "48px",
	  width: "48px",
	  color: "#c0392b",
	  marginTop: "28px"
	};

	
	const warningMessageText = {
	  display: "flex",
	  color: "#1f2933",
	  fontSize: "15px",
	  fontWeight: 500,
	  marginTop: "18px",
	  alignSelf: "center",
	  textAlign: "center",
	  padding: "0 24px"
	};

	
	
	const normalButtonContainer = {
	  display: displayNormalButtons,
	  alignSelf: "center",
	  marginTop: "26px"
	};

	
	const okButton = {
	  display: "flex",
	  alignSelf: "center",

	  height: "36px",
	  minWidth: "80px",
	  padding: "0 20px",

	  alignItems: "center",
	  justifyContent: "center",

	  fontSize: "14px",
	  fontWeight: 500,
	  color: "#ffffff",

	  background: "linear-gradient(180deg, #2f8edc 0%, #1f6fb8 100%)",
	  border: "none",

	  borderRadius: "20px",
	  cursor: "pointer",

	  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
	  transition: "all 0.15s ease-in-out"
	};

	
	const goWarning = (thisText) => {
			setWarningMessage(thisText);
			setDisplayWarning("flex");
	};
	
	const handleSubmitClick = () => {
		if(getCodeFunction() === ""){
			goWarning("A code is required");
		}
		else{
			if(getNameFunction() === ""){
				goWarning("A name is required");
			}
			else{
				functions.getArrayFromAjax("/resolutionsoftwareplatform/" + checkCodeUrl, null, validateCode);
			}
		}
	};
	
	const validateCode = (results) => {
		let exists = false;
		if(parseInt(id) === -100){
			for(let i=0; i<results.length; i++){
				if(results[i].code === getCodeFunction()){
					exists = true;
				}
			}
		}
		if(exists === true){
			goWarning("This code currently exists - please use a different code.");
		}
		else{
			setDisplayProgress("flex");
			const timer = setTimeout(() => {
				goSubmit();	
				setDisplayProgress("none");
			}, 1000);
			
		}
	};
	
	const handleDeleteClick = () => {
		setDisplayWarning("flex");
		setWarningMessage("Are you sure wish to delete?");
		setDisplayNormalButtons("none");
		setDisplayDeleteButtons("flex");
	};
	
	const closeWarning = () => {
		setWarningMessage("");
		setDisplayWarning("none");
	};
	
	const deleteButtonContainer = {
		display:displayDeleteButtons,
		alignSelf:"center",
		marginTop:"20px",
	};
	
	const handleYesClick = () => {
		setDisplayNormalButtons("flex");
		setDisplayDeleteButtons("none");
		setDisplayProgress("flex");
		closeWarning();
			const timer = setTimeout(() => {
				goDelete();	
			}, 1000);
	};
	
	const handleNoClick = () => {
		setDisplayNormalButtons("flex");
		setDisplayDeleteButtons("none");
		closeWarning();
	};
	
	return (
		<div style={editFooter}>
			<div style={editButtonContainer}>
				<div style={adminStyles.menuButton} onClick={handleSubmitClick}>
					Save
				</div>
				<div style={adminStyles.menuButtonDanger} onClick={handleDeleteClick}>
					Delete
				</div>
				<div style={adminStyles.menuButtonCancel} onClick={goCancel}>
					Cancel
				</div>
			</div>
			<div style={progressContainer}>
				<CircularProgress
						color="inherit"
					>
					</CircularProgress>
			</div>
			<div style={warningPopup}>
				<FontAwesomeIcon icon="exclamation-triangle" style={warningTriangle}/>
				<div style={warningMessageText}>
					{warningMessage}
				</div>
				<div style={normalButtonContainer}>
					<div style={okButton} onClick={closeWarning}>
						OK
					</div>
				</div>
				<div style={deleteButtonContainer}>
					<div style={okButton} onClick={handleYesClick}>
						YES
					</div>
					<div style={okButton} onClick={handleNoClick}>
						NO
					</div>
				</div>
			</div>
		</div>
	);
}